import React from 'react';
import { useNavigate } from 'react-router-dom';

export const CardGoalPicker = ({ campaignId, goalMap, value, onSelect }) => {
  const navigate = useNavigate();
  if (!goalMap) return null;
  return (
    <div
      className="mt-3 pt-3 border-t border-divider flex items-center gap-2 flex-wrap"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
      data-testid="card-goal-row"
    >
      <select
        data-testid="card-goal-select"
        value={value || ''}
        onChange={(e) => onSelect(campaignId, e.target.value)}
        className={`text-xs rounded-full px-3 py-1.5 font-semibold focus:outline-none cursor-pointer max-w-[190px] truncate ${
          value
            ? 'bg-lime/10 border border-lime/40 text-lime'
            : 'bg-black border border-divider text-gray hover:text-white'
        }`}
      >
        <option value="">🎯 Choose Goal</option>
        {Object.entries(goalMap).map(([gid, g]) => (
          <option key={gid} value={gid}>{g.label}</option>
        ))}
      </select>
      {value && (
        <button
          data-testid="card-view-stack-link"
          onClick={() => navigate(`/campaign/${campaignId}#recommended-plan`)}
          className="text-xs text-orange hover:underline font-semibold"
        >
          View Recommended Stack →
        </button>
      )}
    </div>
  );
};
